import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { NotificationButton } from '@dotone/react-ui-core';
import { useCurrentUser, useFilterSelector } from '@hooks';
import { fetchUnreadNotifications } from '@actions';

const Notification = (props) => {
  const dispatch = useDispatch();
  const { currentUser, locale } = useCurrentUser();
  const {
    data,
    isLoading,
    status,
    unread,
    locale: loadedLocale,
  } = useFilterSelector(({ notificationUnreadList }) => notificationUnreadList, {
    locale,
  });

  const requestedKey = useRef(null);

  useEffect(() => {
    if (!currentUser.id || isLoading) return;

    const key = `${currentUser.id}-${locale}`;
    if (requestedKey.current === key) return;

    requestedKey.current = key;

    if (status !== 'success' || loadedLocale !== locale) {
      dispatch(fetchUnreadNotifications({ locale }));
    }
  }, [dispatch, currentUser.id, isLoading, status, loadedLocale, locale]);

  return <NotificationButton data={data} unread={unread} isLoading={isLoading} {...props} />;
};

export default Notification;
